import React from "react";

/**
 * Formats numeric values used by dashboard widgets. Kept in one place so
 * every widget renders consistently.
 */
export function formatValue(value, format) {
  if (value === null || value === undefined) return "—";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  if (format === "currency") {
    return `$${num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  }
  if (format === "percent") return `${num.toFixed(1)}%`;
  // Default: integer with thousands separator.
  return num.toLocaleString("en-US");
}

export function TrendBadge({ pct, label }) {
  if (pct === null || pct === undefined || pct === "") {
    return label ? (
      <span className="text-[0.65rem] font-mono-tech tracking-wider text-white/70">
        {label}
      </span>
    ) : null;
  }
  const positive = Number(pct) >= 0;
  return (
    <span
      className={`inline-flex items-center gap-1 text-[0.65rem] font-mono-tech font-bold tracking-wider px-1.5 py-0.5 ${
        positive ? "bg-white/20 text-white" : "bg-black/30 text-white"
      }`}
    >
      <span aria-hidden>{positive ? "▲" : "▼"}</span>
      <span>{Math.abs(Number(pct)).toFixed(1)}%</span>
      {label && <span className="ml-1 opacity-80 normal-case">· {label}</span>}
    </span>
  );
}
